import React, { FC, useState } from "react";
import { AccruedFee, AccruedTime, RiskLevel } from "../../data-types";
import { AccruedFeeList } from "../accrued-fee-list";
import { MatterReportModal } from "../report";
import { MatterDetailsContainer } from "../../../containers/matter-details";
import { HTMLLink } from "../active-matters/active-matters";

export enum LiveMatterOrderBy {
  RiskLevel = "riskLevel",
  RecentlyAdded = "recentlyAdded",
  RecentWork = "recentWork",
}

type ActiveMattersStatusFilterListProps = {
  accruedFees: AccruedFee[];
  link: HTMLLink;
  loading: boolean;
  onLoadMore: (nextTake: number) => void;
  total: number;
  filterBy: "user" | "organisationalUnit";
  orderBy: LiveMatterOrderBy;
};

type MatterDetailsState = {
  show: boolean;
  currentAccruedFee: AccruedFee;
  matterId?: number;
  matterTitle?: string;
  clientName?: string;
  accruedTimes?: AccruedTime[];
  currentGpm?: number;
  currentGpmRiskLevel?: RiskLevel;
  gpmSource?: string;
  targetGpm?: number;
};

const INITIAL_MATTER_DETAILS_STATE: MatterDetailsState = {
  show: false,
  currentAccruedFee: {} as AccruedFee,
};

type ReportState = {
  show: boolean;
  matterId?: number;
  matterTitle?: string;
  clientName?: string;
  accruedFee?: AccruedFee;
};
const INITIAL_REPORT_STATE: ReportState = { show: false };

export const ActiveMattersStatusFilterList: FC<ActiveMattersStatusFilterListProps> = ({
  accruedFees,
  link,
  loading,
  total,
  onLoadMore,
  filterBy,
  orderBy,
}) => {
  const [matterDetailsState, setMatterDetailsState] = useState(INITIAL_MATTER_DETAILS_STATE);
  const [reportState, setReportState] = useState(INITIAL_REPORT_STATE);

  const showTimeLog = (matterId: number) => {
    const currentMatter = accruedFees.find((a: any) => a.matterId === matterId);
    const currentMatterTitle = currentMatter?.matterTitle || "";
    const currentClientName = currentMatter?.clientName || "";
    const currentAccruedTimes = currentMatter?.accruedTimes || [];
    const currentGpm = currentMatter?.actualGpm;
    const currentGpmRiskLevel = currentMatter?.actualGpmRiskLevel;

    if (!matterId || !currentMatter) {
      return;
    }

    setMatterDetailsState({
      show: true,
      matterId,
      matterTitle: currentMatterTitle,
      clientName: currentClientName,
      accruedTimes: currentAccruedTimes,
      currentGpm,
      currentGpmRiskLevel,
      gpmSource: currentMatter?.gpmSource,
      targetGpm: currentMatter?.gpmDangerThreshold,
      currentAccruedFee: currentMatter,
    });
  };

  const showReport = (matterId: number) => {
    const currentMatter = accruedFees.find((a: any) => a.matterId === matterId);

    if (!matterId || !currentMatter) {
      return;
    }

    setReportState({
      show: true,
      matterId,
      accruedFee: currentMatter,
    });
  };

  return (
    <>
      <AccruedFeeList
        onLoadMore={onLoadMore}
        loading={loading}
        total={total}
        onShowTimeLogs={showTimeLog}
        onShowReport={showReport}
        accruedFees={accruedFees}
        link={link}
        filterBy={filterBy}
        orderBy={orderBy}
      />
      {matterDetailsState.show && matterDetailsState.matterId && (
        // <AccruedTimeLogModal
        //   accruedFee={matterDetailsState.currentAccruedFee}
        //   show={true}
        //   onClose={() => setMatterDetailsState(INITIAL_MATTER_DETAILS_STATE)}
        //   loading={false}
        //   matterTitle={matterDetailsState.matterTitle || ""}
        //   clientName={matterDetailsState.clientName || ""}
        //   accruedTimes={matterDetailsState.accruedTimes || []}
        //   currentGpm={matterDetailsState.currentGpm || 0}
        //   currentGpmRiskLevel={matterDetailsState.currentGpmRiskLevel || RiskLevel.LowRisk}
        //   gpmSource={matterDetailsState.gpmSource || ""}
        //   targetGpm={matterDetailsState.targetGpm || 0}
        // />
        <MatterDetailsContainer
          matterId={matterDetailsState.matterId}
          accruedFee={matterDetailsState.currentAccruedFee}
          show={true}
          onClose={() => setMatterDetailsState(INITIAL_MATTER_DETAILS_STATE)}
          loading={false}
          matterTitle={matterDetailsState.matterTitle || ""}
          clientName={matterDetailsState.clientName || ""}
          accruedTimes={matterDetailsState.accruedTimes || []}
          currentGpm={matterDetailsState.currentGpm || 0}
          currentGpmRiskLevel={matterDetailsState.currentGpmRiskLevel || RiskLevel.LowRisk}
          gpmSource={matterDetailsState.gpmSource || ""}
          targetGpm={matterDetailsState.targetGpm || 0}
          currencySymbol={matterDetailsState.currentAccruedFee.currencySymbol || ""}
        />
      )}
      {reportState.show && reportState.matterId && (
        <MatterReportModal
          show={true}
          matterId={reportState.matterId}
          accruedFee={reportState.accruedFee}
          onClose={() => setReportState(INITIAL_REPORT_STATE)}
        />
      )}
    </>
  );
};
